<template>
  <div class="main">
    <a-table
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="lists"
      :pagination="pagination"
      :loading="tableLoading"
      @change="handleTableChange"
    >
      <template slot="title">
        <a-button @click="add">新增图片</a-button></template
      >
      <template slot="pic" slot-scope="text"> <img :src="text"/></template>

      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          title="确定要删除么"
          okText="确定"
          cancelText="取消"
          @confirm="del(record.id)"
        >
          <a-icon slot="icon" type="warning" style="color: red" />
          <a class="active">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-modal
      v-model="visible"
      title="新增模板"
      :footer="null"
      width="500px"
      @cancel="close"
    >
      <a-form
        id="components-form-demo-validate-other"
        :form="form"
        @submit="handleSubmit"
        ref="form"
      >
        <a-form-item label="标题 (必填)">
          <a-input
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    type: 'any'
                  },
                  {
                    required: true,
                    pattern: /^[A-Za-z0-9]+$/,
                    message: '请填写标题,且只能用字母和数字'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="模板图片">
          <a-upload-dragger
            accept="image/*"
            name="file"
            :multiple="true"
            :headers="headers"
            :beforeUpload="beforeUpload"
            v-decorator="['photo']"
            v-if="photo == ''"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-hint">点击上传模板图片</p>
          </a-upload-dragger>
          <div v-else class="cover-img" @click="clearImg()">
            <img :src="photo" style="height: 100%;width: 100%" />
          </div>
        </a-form-item>
        <a-form-item style="margin:0 auto;width:70px;">
          <a-button type="primary" html-type="submit">
            添加
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '图片名称',
    dataIndex: 'title',
    scopedSlots: { customRender: 'headTitle' },
    width: '300px'
  },
  {
    title: '图片样式',
    scopedSlots: { customRender: 'pic' },
    dataIndex: 'pic'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    with: 400
  }
];
export default {
  data() {
    return {
      columns,
      param: { page: 1, limit: 20 },
      tableLoading: false,
      lists: [],
      pagination: {
        pageSize: 20
      },
      visible: false,
      form: this.$form.createForm(this, { name: 'form' }),
      photo: '',
      headers: {
        //上传图片至云图库的请求头
        Authorization: window.localStorage.getItem('token')
      }
    };
  },
  methods: {
    getPicList(param) {
      this.tableLoading = true;
      this.$http
        .post('http://127.0.0.1:8360/api/special/picList', param)
        .then(res => {
          const pagination = { ...this.pagination };
          if (res.data.errno === 0) {
            this.lists = res.data.data.lists;
            pagination.total = res.data.data.total;
          } else {
            pagination.total = 0;
            this.lists = [];
          }
          this.tableLoading = false;
          this.pagination = pagination;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = pagination.current;
      this.pagination = pagination;
      this.getPicList(this.param);
    },
    add() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.photo == '') {
            this.$message.error('图片不能为空');
            return false;
          } else {
            let data = {
              title: values.title,
              pic: this.photo + '/thumb_400'
            };
            this.$http
              .post('http://127.0.0.1:8360/api/special/addPic', data)
              .then(res => {
                if (res.data.errno == 0) {
                  //上传,更新成功
                  this.$message.success('上传成功');
                  this.getPicList(this.param);
                  this.close();
                } else {
                  this.$message.error(res.data.errmsg);
                }
              });
          }
        }
      });
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.photo = result.data.data;
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    clearImg() {
      let that = this;
      this.$confirm({
        title: '删除封面图',
        content: '确认删除当前专题的封面图吗？',
        onOk() {
          that.photo = '';
        },
        onCancel() {}
      });
    },
    del(id) {
      this.$http
        .post('http://127.0.0.1:8360/api/special/delPic', { id })
        .then(res => {
          if (res.data.errno === 0) {
            this.$message.success('删除成功');
          } else {
            this.$message.error('删除失败');
          }
          this.getPicList(this.param);
        });
    }
  },
  created() {
    this.getPicList(this.param);
  },
  mounted() {}
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.upload-div {
  width: 278px;
  background-color: #fafafa;
  border: 1px dashed #dedede;
  border-radius: 3px;
}
</style>
